// Mock data for Dark Tourism Malaysia website

export const heroContent = {
  title: "Dark Tourism Malaysia",
  subtitle: "Places remember.",
  description: "Documenting places across Malaysia connected to memory, tragedy, conflict, and historical depth. Over 250 sites preserving histories that shaped the nation."
};

export const featuredSites = [
  {
    id: 1,
    name: "Penang War Museum",
    location: "Penang",
    category: "War and Conflict",
    image: "/images/penang-war-museum-1.jpg",
    description: "Built on the site of a former British fortress, it preserves tunnels, bunkers, and wartime relics. Often labeled as 'haunted,' it is one of the most important war heritage sites in Southeast Asia.",
    darkLevel: "Darkest",
    typology: "War and battlefield tourism"
  },
  {
    id: 2,
    name: "Villa Nabila",
    location: "Johor Bahru",
    category: "Colonial and Abandoned Heritage",
    image: "/images/villa-nabila-exploring.jpg",
    description: "A decaying hilltop bungalow overlooking Danga Bay with tales that emerged in the 1970s. It became a staple of Malaysian urban folklore and inspired film adaptations.",
    darkLevel: "Medium",
    typology: "Ghost and paranormal tourism"
  },
  {
    id: 3,
    name: "Kellie's Castle",
    location: "Perak",
    category: "Colonial and Abandoned Heritage",
    image: "/images/kellies-castle.jpg",
    description: "An unfinished colonial mansion built by Scottish planter William Kellie Smith. It carries stories of architectural ambition, hidden rooms, and lingering mysteries surrounding its abrupt abandonment.",
    darkLevel: "Medium",
    typology: "Colonial heritage tourism"
  },
  {
    id: 4,
    name: "Fort Margherita",
    location: "Kuching, Sarawak",
    category: "Colonial and Social History",
    image: "/images/fort-margarita-kuching.jpg",
    description: "A white fortress built by Charles Brooke in 1879 during the era of the White Rajahs. It served as a defensive position overlooking the Sarawak River and witnessed the complex colonial history of Borneo.",
    darkLevel: "Medium",
    typology: "Colonial heritage tourism"
  },
  {
    id: 5,
    name: "Parit Sulong Bridge",
    location: "Johor",
    category: "War and Conflict",
    image: "/images/parit-sulong.jpg",
    description: "The location of a WWII massacre involving Australian and Indian soldiers. Though the original bridge no longer stands, the events remain an important part of Malaysia's wartime history.",
    darkLevel: "Dark",
    typology: "War and battlefield tourism"
  },
  {
    id: 6,
    name: "Old Courthouse Kuching",
    location: "Kuching, Sarawak",
    category: "Colonial and Social History",
    image: "/images/old-courthouse-kuching.jpg",
    description: "A tranquil courtyard surrounded by colonial buildings now housing cafés and galleries. During the Japanese occupation, it became a center for trials and executions linked to wartime administration.",
    darkLevel: "Darkest",
    typology: "Incarceration and detention tourism"
  }
];

export const worldSites = [
  {
    name: "Auschwitz-Birkenau",
    location: "Poland",
    image: "https://images.unsplash.com/photo-1756507176200-86956fda9e9b?w=800",
    description: "The largest Nazi concentration and extermination camp, now a UNESCO World Heritage Site and museum dedicated to Holocaust remembrance."
  },
  {
    name: "Chernobyl Exclusion Zone",
    location: "Ukraine",
    image: "https://images.unsplash.com/photo-1759350007447-b0da859d59e7?w=800",
    description: "Site of the 1986 nuclear disaster, now a haunting reminder of technological failure and human resilience."
  },
  {
    name: "Ground Zero",
    location: "New York, USA",
    image: "https://images.unsplash.com/photo-1619521495556-3ddfb0e155a0?w=800",
    description: "Memorial site of the September 11, 2001 terrorist attacks, honoring nearly 3,000 victims."
  }
];

export const seaSites = [
  {
    name: "Cu Chi Tunnels",
    location: "Vietnam",
    image: "https://images.unsplash.com/photo-1639211025612-ffd808daa21a?w=800",
    description: "An extensive underground network used by Viet Cong soldiers during the Vietnam War."
  },
  {
    name: "Tuol Sleng Genocide Museum",
    location: "Cambodia",
    image: "https://images.unsplash.com/photo-1756507175997-7dfc3ff3b353?w=800",
    description: "Former high school turned into Security Prison 21 by the Khmer Rouge regime."
  },
  {
    name: "Changi Chapel and Museum",
    location: "Singapore",
    image: "https://images.unsplash.com/photo-1621777222149-d58f10af6258?w=800",
    description: "Commemorates the suffering of POWs during the Japanese Occupation of Singapore."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Fading Traces of War: Kelantan's Forgotten Pillboxes",
    author: "Dr. Sarah Ahmad",
    date: "2024-12-15",
    category: "Field Notes",
    excerpt: "Along the coast of Kelantan, weathered concrete structures stand half-buried in sand and overgrown vegetation. These are British pillboxes from World War II, silent witnesses to a time when invasion seemed imminent...",
    image: "https://images.unsplash.com/photo-1759350007447-b0da859d59e7?w=800",
    isPremium: false
  },
  {
    id: 2,
    title: "Before They Vanish: Documenting Bidong Island",
    author: "Dr. Sarah Ahmad",
    date: "2024-11-28",
    category: "Preservation",
    excerpt: "Bidong Island once sheltered over 40,000 Vietnamese refugees. Today, their legacy is disappearing. Structures are collapsing, inscriptions fading. This is a race against time...",
    image: "https://images.unsplash.com/photo-1755103910213-ac38c8782328?w=800",
    isPremium: true
  },
  {
    id: 3,
    title: "Sacred Ground: Understanding Cemetery Tourism in Malaysia",
    author: "Dr. Sarah Ahmad",
    date: "2024-11-10",
    category: "Cultural Perspectives",
    excerpt: "In Malaysia's multicultural landscape, cemeteries are more than final resting places. They are archives of migration, conflict, and community. How do we approach them respectfully?",
    image: "https://images.unsplash.com/photo-1619521495806-7b8367a1e79f?w=800",
    isPremium: true
  }
];

export const mediaFeatures = [
  {
    year: 2024,
    items: [
      {
        title: "Dark Tourism in Malaysia: An Academic Perspective",
        outlet: "The Star",
        date: "December 2024",
        url: "#"
      },
      {
        title: "Preserving Difficult Histories",
        outlet: "Astro Awani",
        date: "November 2024",
        url: "#"
      }
    ]
  },
  {
    year: 2023,
    items: [
      {
        title: "Beyond Ghost Stories: Malaysia's Heritage Sites",
        outlet: "Malay Mail",
        date: "October 2023",
        url: "#"
      }
    ]
  }
];

export const darkTourismTypologies = [
  {
    id: 1,
    name: "War and Battlefield Tourism",
    description: "Sites where armed conflict took place",
    examples: "Penang War Museum, Sandakan Death March, Bukit Kepong"
  },
  {
    id: 2,
    name: "Genocide Tourism",
    description: "Locations connected to systematic mass killings",
    examples: "Memorials related to wartime atrocities"
  },
  {
    id: 3,
    name: "Disaster Tourism",
    description: "Natural or man-made disaster sites",
    examples: "Highland Towers site, tsunami-affected areas"
  },
  {
    id: 4,
    name: "Cemetery and Burial Tourism",
    description: "Historic graveyards and memorial sites",
    examples: "Old Protestant Cemetery Penang, Chinese cemeteries"
  },
  {
    id: 5,
    name: "Incarceration and Detention Tourism",
    description: "Former prisons and detention facilities",
    examples: "Pudu Jail (demolished), Jerejak Island prison"
  },
  {
    id: 6,
    name: "Medical and Epidemic Tourism",
    description: "Sites connected to disease and medical history",
    examples: "Sungai Buloh Leprosy Settlement, plague cemeteries"
  },
  {
    id: 7,
    name: "Colonial Tourism",
    description: "Heritage connected to colonial rule",
    examples: "Fort Cornwallis, colonial administrative buildings"
  },
  {
    id: 8,
    name: "Slavery and Forced Labor Tourism",
    description: "Sites of human exploitation",
    examples: "Tin mining heritage sites, plantation histories"
  },
  {
    id: 9,
    name: "Assassination and Political Violence",
    description: "Locations of political killings",
    examples: "Sites of emergency-era violence"
  },
  {
    id: 10,
    name: "Religious Martyrdom and Pilgrimage",
    description: "Sacred sites connected to suffering",
    examples: "Various religious memorial sites"
  }
];

export const visitorGuidelines = {
  dos: [
    {
      title: "Show Respect",
      description: "Approach these sites with reverence and understanding. They represent real loss and suffering."
    },
    {
      title: "Learn the History",
      description: "Research the site beforehand. Understanding context enriches your visit and shows respect."
    },
    {
      title: "Dress Appropriately",
      description: "Wear modest, respectful clothing, especially at religious or memorial sites."
    },
    {
      title: "Observe Quiet Reflection",
      description: "These are places for contemplation, not entertainment. Maintain a respectful demeanor."
    },
    {
      title: "Support Preservation",
      description: "Where possible, contribute to the maintenance and preservation of these important sites."
    }
  ],
  donts: [
    {
      title: "Avoid Paranormal Framing",
      description: "Do not approach these sites as 'haunted' locations or centers of supernatural activity."
    },
    {
      title: "No Insensitive Photography",
      description: "Avoid selfies or playful poses at sites of tragedy. Photography should be respectful and documentary."
    },
    {
      title: "Do Not Litter or Damage",
      description: "Leave sites as you found them. Do not remove artifacts or leave trash behind."
    },
    {
      title: "Respect Religious Practices",
      description: "Be aware of ongoing religious significance. Do not enter restricted areas or interrupt ceremonies."
    },
    {
      title: "Avoid Personal Rituals",
      description: "Do not perform séances, spirit communication, or other paranormal activities at these sites."
    },
    {
      title: "Be Mindful of Context",
      description: "Remember these sites represent real people's suffering. Treat them with the gravity they deserve."
    }
  ]
};

export const itineraries = [
  {
    id: 1,
    title: "WWII Heritage Trail - Penang & Perak",
    duration: "3 Days",
    difficulty: "Moderate",
    description: "Explore Malaysia's World War II history through preserved bunkers, war museums, and memorial sites.",
    stops: ["Penang War Museum", "Fort Cornwallis", "Ipoh War Cemetery", "Death Railway remnants"]
  },
  {
    id: 2,
    title: "Colonial Echoes - Malacca & Penang",
    duration: "4 Days",
    difficulty: "Easy",
    description: "Journey through centuries of colonial history, visiting forts, cemeteries, and administrative buildings.",
    stops: ["A Famosa", "St. Paul's Hill", "Fort Cornwallis", "Protestant Cemetery"]
  },
  {
    id: 3,
    title: "Sites of Resilience - Sabah",
    duration: "5 Days",
    difficulty: "Challenging",
    description: "Follow the Sandakan Death March route and visit memorials honoring POW suffering.",
    stops: ["Sandakan Memorial Park", "Ranau", "Kundasang War Memorial"]
  }
];

export const myths = [
  {
    id: 1,
    myth: "Dark tourism is about ghost hunting and the supernatural",
    reality: "Dark tourism focuses on history, memory, and understanding the past—not paranormal activity. It's about learning from tragedy and honoring those who suffered."
  },
  {
    id: 2,
    myth: "Visiting such places is disrespectful or taboo",
    reality: "Respectful visits for learning and remembrance are accepted across cultures. What matters is the intention and manner of engagement."
  },
  {
    id: 3,
    myth: "Dark tourism does not exist in Malaysia",
    reality: "Malaysia holds a wide range of dark tourism sites, from WWII battlefields to colonial prisons, covering centuries of history."
  },
  {
    id: 4,
    myth: "These places are only for foreign tourists",
    reality: "There is growing Malaysian interest in understanding difficult national histories. These sites belong to everyone."
  },
  {
    id: 5,
    myth: "Dark tourism is exploitative by nature",
    reality: "The risk exists, but responsible interpretation, education, and respect make ethical dark tourism possible."
  }
];

export const collaborationTypes = [
  {
    title: "Museums and Heritage Organizations",
    description: "Partner with us to document and preserve historical sites"
  },
  {
    title: "Historians and Researchers",
    description: "Contribute academic insights and historical documentation"
  },
  {
    title: "Tour Operators",
    description: "Develop respectful, educational dark tourism experiences"
  },
  {
    title: "Universities",
    description: "Collaborate on research projects and student engagement"
  },
  {
    title: "Media Organizations",
    description: "Share stories that raise awareness and promote understanding"
  }
];
